<div>
  <div *ngIf="error_Message" class="error-message text-red mb-4 text-sm">{{ error_Message }}</div>
  <form id="form-container" method="post" action="/charge">
    <!-- Tap element will be here -->
    <div id="element-container"></div>
    <!-- Tap pay button -->
    <!-- <button class="btn btn-primary" *ngIf="tapLoaded">Submit</button> -->
  </form>
</div>
